import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { postData } from "../utility/Utility";

// Define all menu items with correct permission names matching your backend
const allMenuItems = [
  {
    id: 1,
    title: "Dashboard",
    icon: "fa-solid fa-gauge",
    link: "/dashboard",
    permissionName: "admindashboard",
  },
  {
    id: 0,
    title: "Welcome",
    icon: "fa-solid fa-home",
    link: "/welcome",
    permissionName: "welcomeDashboard",
  },
  {
    id: 2,
    title: "User Management",
    icon: "fa-solid fa-users",
    link: "/user-management",
    permissionName: "userManagement",
    subItems: [
      {
        id: 21,
        title: "User Management",
        icon: "fa-solid fa-users",
        link: "/user-management",
        permissionName: "userManagement",
      },
      {
        id: 22,
        title: "Manage Delete Requests",
        icon: "fa-solid fa-trash-can-arrow-up",
        link: "/manage-delete-requests",
        permissionName: "manageAccountDeletionRequest",
      },
    ],
  },
  {
    id: 3,
    title: "Role Management",
    icon: "fa-solid fa-user-tag",
    link: "/role-list",
    permissionName: "roleManagement",
  },
  {
    id: 31,
    title: "Designation Management",
    icon: "fa-solid fa-id-card",
    link: "/designation-list",
    permissionName: "designationManagement",
  },
  {
    id: 18,
    title: "Holiday Management",
    icon: "fa-solid fa-calendar-days",
    link: "/holiday-calendar",
    permissionName: "HolidayCalendar",
    subItems: [
      {
        id: 181,
        title: "Holiday Calendar",
        icon: "fa-solid fa-calendar",
        link: "/holiday-calendar",
        permissionName: "HolidayCalendar",
      },
      {
        id: 182,
        title: "Event Templates",
        icon: "fa-solid fa-envelope",
        link: "/event-templates",
        permissionName: "HolidayCalendar",
      },
    ],
  },
  {
    id: 19,
    title: "Greeting Card Management",
    icon: "fa-solid fa-envelope",
    link: "/greeting-card-list",
    permissionName: "GreetingCardManagement",
    subItems: [
      {
        id: 192,
        title: "Greeting Card Calendar",
        icon: "fa-solid fa-calendar",
        link: "/greeting-card-calendar",
        permissionName: "GreetingCardManagement",
      },
      {
        id: 191,
        title: "Greeting Card List",
        icon: "fa-solid fa-list",
        link: "/greeting-card-list",
        permissionName: "GreetingCardManagement",
      },
    ],
  },
  {
    id: 4,
    title: "Inquiries Management",
    icon: "fa-solid fa-question-circle",
    link: "/inquiries-management",
    permissionName: "websitesInquiryFrom",
    subItems: [
      {
        id: 41,
        title: "Inquiries Form",
        icon: "fa-solid fa-question",
        link: "/inquiries-management",
        permissionName: "websitesInquiryFrom",
      },
      {
        id: 42,
        title: "Dashboard Inquiries",
        icon: "fa-solid fa-table-list",
        link: "/all-enquiries",
        permissionName: "websitesHomePageInquiry",
      },
      {
        id: 43,
        title: "Contact Form Inquiries",
        icon: "fa-solid fa-table-list",
        link: "/contact-form-inquiry",
        permissionName: "websitesContactInquiry",
      },
      {
        id: 44,
        title: "Partner Form Inquiries",
        icon: "fa-solid fa-table-list",
        link: "/partner-form-inquiry",
        permissionName: "websitesPartnerInquiry",
      },
      {
        id: 45,
        title: "Agent Meeting Form Inquiries",
        icon: "fa-solid fa-handshake",
        link: "/agent-meeting-lead",
        permissionName: "websitesAgentMeetingInquiry",
      },
      {
        id: 46,
        title: "Agent Home Visits Lead",
        icon: "fa-solid fa-handshake",
        link: "/home-visits-lead",
        permissionName: "websitesAgentPhysicalInquiry",
      },
      {
        id: 123,
        title: "CSV Upload",
        icon: "fa-solid fa-file",
        link: "/csv-lead-list",
        permissionName: "CSVLeadManagement",
      },
    ],
  },
  {
    id: 5,
    title: "Insurance Management",
    icon: "fa-solid fa-file-contract",
    link: "/category-list",
    permissionName: "CategoryManagement",
    subItems: [
      {
        id: 51,
        title: "Category Management",
        icon: "fa-solid fa-tags",
        link: "/category-list",
        permissionName: "CategoryManagement",
      },
      {
        id: 52,
        title: "Sub-category Management",
        icon: "fa-solid fa-tag",
        link: "/subcategory-list",
        permissionName: "SubCategoryManagement",
      },
    ],
  },
  {
    id: 6,
    title: "Employee Management",
    icon: "fa-solid fa-id-card",
    link: "/employee-list",
    permissionName: "EmployeeManagement",
  },
  {
    id: 47,
    title: "Followup Leads",
    icon: "fa-solid fa-clock-rotate-left",
    link: "/followup-leads",
    permissionName: "websitesHomePageInquiry",
  },
  {
    id: 7,
    title: "Home Management",
    icon: "fa-solid fa-home",
    link: "/hero-slider-list",
    permissionName: "HeroSliderManagement",
    subItems: [
      {
        id: 72,
        title: "Hero Slider Management",
        icon: "fa-solid fa-images",
        link: "/hero-slider-list",
        permissionName: "HeroSliderManagement",
      },
      {
        id: 73,
        title: "Testimonial Management",
        icon: "fa-solid fa-quote-left",
        link: "/testimonial-list",
        permissionName: "TestimonialsManagement",
      },
      {
        id: 74,
        title: "Partner Management",
        icon: "fa-solid fa-handshake",
        link: "/partner-list",
        permissionName: "PartnersManagement",
      },
      {
        id: 75,
        title: "Team Member Management",
        icon: "fa-solid fa-users",
        link: "/team-member-list",
        permissionName: "TeamMemberManagement",
      },
      {
        id: 53,
        title: "Gallery Management",
        icon: "fa-solid fa-images",
        link: "/gallery-list",
        permissionName: "GalleryManagement",
      },
    ],
  },
  {
    id: 9,
    title: "Notification Management",
    icon: "fa-solid fa-bell",
    link: "/notification-list",
    permissionName: "NotificationManagement",
  },

  {
    id: 8,
    title: "Vehicle Management",
    icon: "fa-solid fa-car",
    link: "/manufacturers-company-subcategory-list",
    permissionName: "VehicleManufacturers",
    subItems: [
      // {
      //   id: 75,
      //   title: "Manufacturers Company",
      //   icon: "fa-solid fa-users",
      //   link: "/manufacturers-list",
      //   permissionName: "VehicleManufacturers",
      // },
      {
        id: 23,
        title: "Vehicle Type",
        icon: "fa-solid fa-motorcycle",
        link: "/manufacturers-company-subcategory-list",
        permissionName: "VehicleProjects",
      },
    ],
  },

  {
    id: 8,
    title: "Commission Management",
    icon: "fa-solid fa-percent",
    link: "/commission-list",
    permissionName: "CommissionManagement",
    subItems: [
      {
        id: 75,
        title: "Commission settings",
        icon: "fa-solid fa-users",
        link: "/commission-list",
        permissionName: "CommissionManagement",
      },
      {
        id: 76,
        title: "Reward settings",
        icon: "fa-solid fa-trash-can-arrow-up",
        link: "/reward-list",
        permissionName: "RewardManagement",
      },
    ],
  },

  {
    id: 11,
    title: "User Policy Management",
    icon: "fa-solid fa-file-signature",
    link: "/user-policy-list-by-agent",
    permissionName: "PolicyManagement",
  },
  {
    id: 12,
    title: "Feedback Management",
    icon: "fa-solid fa-comment-dots",
    link: "/feedback-list",
    permissionName: "FeedbackManagement",
  },
  // {
  //   id: 17,
  //   title: "Event Management",
  //   icon: "fa-solid fa-calendar",
  //   link: "/event-management",
  //   permissionName: "EventManagement",
  // },
  {
    id: 14,
    title: "Voucher",
    icon: "fa-solid fa-book",
    link: "/voucherlist",
    permissionName: "VoucherManagement",
    subItems: [
      {
        id: 141,
        title: "Voucher List",
        icon: "fa-solid fa-list",
        link: "/voucherlist",
        permissionName: "VoucherManagement",
      },
      {
        id: 142,
        title: "Policy Reward List",
        icon: "fa-solid fa-plus",
        link: "/reward-points",
        permissionName: "VoucherManagement",
      },
    ],
  },

  {
    id: 15,
    title: "Help and Support Management",
    icon: "fa-solid fa-headset",
    link: "/help-and-support-list",
    permissionName: "HelpAndSupportManagement",
  },

  {
    id: 20,
    title: "XOXO Dashboard",
    icon: "fa-solid fa-coins",
    link: "/xoxo-dashboard",
    permissionName: "XOXODashboard",
    subItems: [
      {
        id: 201,
        title: "Dashboard",
        icon: "fa-solid fa-gauge",
        link: "/xoxo-dashboard",
        permissionName: "XOXODashboard",
      },
      {
        id: 202,
        title: "Order History",
        icon: "fa-solid fa-history",
        link: "/xoxo-order-history",
        permissionName: "XOXOOrderHistory",
      },
      {
        id: 203,
        title: "Payment History",
        icon: "fa-solid fa-credit-card",
        link: "/xoxo-payment-history",
        permissionName: "XOXOPaymentHistory",
      },
    ],
  },

  {
    id: 16,
    title: "Settings",
    icon: "fa-solid fa-gear",
    link: "/setting",
    permissionName: "SettingsManagement",
    subItems: [
      {
        id: 161,
        title: "IP Management",
        icon: "fa-solid fa-network-wired",
        link: "/ip-list",
        permissionName: "ipManagement",
        // showByDefault: true,
      },
      {
        id: 162,
        title: "Project Setting",
        icon: "fa-solid fa-network-wired",
        link: "/project-setting",
        permissionName: "ProjectSetting",
        // showByDefault: true,
      },
      {
        id: 163,
        title: "Message Setting",
        icon: "fa-solid fa-network-wired",
        link: "/setting",
        permissionName: "MessageSetting",
        // showByDefault: true,
      },
    ],
  },
];

function Sidebar() {
  const [userData, setUserData] = useState(null);
  console.log("Rendering Sidebar component", userData);
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();


  console.log("User Data in sidebar:", userData);

  const fetchProfileData = async () => {
    try {
      const response = await postData("api/admin/profile");
      if (response?.success) {
        // Store both user data and permission data
        setUserData({
          ...response.data,
          role: response.data?.role,
          permission: response.permission?.permission || [],
        });
      }
      console.log("Profile Data Response:", response);
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfileData();

    // Load Font Awesome if not already loaded
    if (!document.querySelector('[href*="font-awesome"]')) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";
      document.head.appendChild(link);
    }
  }, []);

  // Filter menu items based on permissions and role
  const getFilteredMenuItems = () => {
    // If no user data loaded yet, show nothing
    if (!userData) {
      return [];
    }

    console.log("User role:", userData.role);
    console.log(
      "Available permissions:",
      userData.permission?.map((p) => p.permissionName)
    );

    // If user is Super Admin, return all menu items except welcome
    if (userData.role === "super-admin") {
      return allMenuItems.filter(item => item.permissionName !== "welcomeDashboard");
    }

    // For regular users, filter based on permissions but always include welcome
    const filteredItems = allMenuItems.filter((item) => {
      // Always show welcome dashboard for authenticated users
      if (item.permissionName === "welcomeDashboard") {
        return true;
      }

      // Check other permissions
      if (!userData.permission || !Array.isArray(userData.permission)) {
        return false;
      }

      return userData.permission.some(
        (permission) => permission.permissionName === item.permissionName
      );
    });

    return filteredItems.map((item) => {
      // Filter subItems based on permissions
      if (item.subItems) {
        const filteredSubItems = item.subItems.filter((subItem) => {
          if (!userData.permission || !Array.isArray(userData.permission)) {
            return false;
          }
          return userData.permission.some(
            (permission) => permission.permissionName === subItem.permissionName
          );
        });

        return {
          ...item,
          subItems: filteredSubItems.length > 0 ? filteredSubItems : null,
        };
      }
      return item;
    });
  };

  const handleMenuClick = (link) => {
    if (activeMenu === link) {
      setActiveMenu(null);
    } else {
      setActiveMenu(link);
    }
  };

  const handleLinkClick = (e, link, hasSubItems) => {
    e.preventDefault();
    if (!hasSubItems) {
      navigate(link);
    }
  };

  const menuItems = getFilteredMenuItems();

  console.log("Filtered menu items:", menuItems);

  // Show loading state if user data is being fetched
  if (!userData) {
    return (
      <div className="app-sidebar-menu">
        <div className="sidebar-menu-inner" data-simplebar>
          <div className="text-center p-3">Loading permissions...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-sidebar-menu">
      <div className="sidebar-menu-inner" data-simplebar>
        <div id="sidebar-menu" className="pt-3">
          <div className="logo-box">
            <Link className="logo logo-light" to="#">
              <span className="logo-lg">
                <img
                  src="/assets/logo/Surelogo.png"
                  alt="Company Logo"
                  style={{ maxHeight: "50px", width: "auto" }}
                />
              </span>
            </Link>
            <Link className="logo logo-dark" to="#">
              <span className="logo-lg">
                <img
                  src="/assets/logo/Surelogo.png"
                  alt="Company Logo"
                  style={{ maxHeight: "50px", width: "auto" }}
                />
              </span>
            </Link>
          </div>

          <ul id="side-menu" className="overflow-y">
            {menuItems.length === 0 ? (
              <li className="text-center p-3 text-muted">
                No menu items available based on your permissions
              </li>
            ) : (
              menuItems.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.link}
                    className={location.pathname === item.link ? "active" : ""}
                    onClick={(e) => {
                      handleMenuClick(item.link);
                      handleLinkClick(e, item.link, item.subItems);
                    }}
                  >
                    <i className={`${item.icon} me-2`}></i>
                    <span>{item.title}</span>
                    {item.subItems && item.subItems.length > 0 && (
                      <span className="menu-arrow"></span>
                    )}
                  </a>
                  {item.subItems && item.subItems.length > 0 && (
                    <div
                      className={`collapse ${activeMenu === item.link ? "show profileshow" : ""
                        }`}
                      id={item.link.substring(1)}
                    >
                      <ul className="nav-second-level">
                        {item.subItems.map((subItem, subIndex) => (
                          <li key={subIndex}>
                            <a
                              className="tp-link"
                              href={subItem.link}
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(subItem.link);
                              }}
                            >
                              {subItem.title}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              ))
            )}
          </ul>
        </div>
        <div className="clearfix"></div>
      </div>
    </div>
  );
}

export default Sidebar;
